import React from "react";
import styles from "./style.module.css";
import { images } from "../../../../assets/images";
import DownloadButton from "../../../../components/DownloadButton";

const ContactUs = () => {
  const { AppleBlack, PlayBlack } = images;
  const { DesignItem } = images;
  return (
    <div className={styles.pageContainer}>
      <img className={styles.DesignItem} src={DesignItem} alt="" />
      <div className={styles.LeftContainer}>
        <h2 className={styles.heading1}>
          Looking forward to having you onboard with us!
        </h2>
        <div className={styles.buttonsContainer}>
          <DownloadButton
            height="30px"
            width="30px"
            bgColor="white"
            textColor="black"
            icon={AppleBlack}
            text="Download on App Store"
          />
          <DownloadButton
            bgColor="white"
            textColor="black"
            icon={PlayBlack}
            text="Download on Play Store"
          />
        </div>
      </div>
      <div className={styles.rightContainer}>
        <p>Please feel free to reach out to us if you have any query.</p>
        <div className={styles.buttonsContainer2}>
          <button className={styles.contactButton}>Contact Us</button>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
